import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import api from '../../axiosConfig';
import Modal from 'bootstrap/js/dist/modal';
import SupportTracker from '../child/SupportTracker';


export default function TablaSincronizaciones() {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [editingUser, setEditingUser] = useState(null);
    const [estatusDto, setEstatusDto] = useState(null);
    const [selectedEmpleado, setSelectedEmpleado] = useState(null);


    const [modalAnio, setModalAnio] = useState(0);
    const [modalNoPeriodo, setModalNoPeriodo] = useState(0);



    const rfcRef = useRef();
    const nombreRef = useRef();
    const curpRef = useRef();
    

    const autorizacionRef = useRef();
    const [httpCode, setHttpCode] = useState(0);

    // >>>>>>>>>> NUEVO: refs para polling y modal
    const pollingRef = useRef(null);
    const modalElRef = useRef(null);


    useEffect(() => {

        fetchNotificaciones();

    }, []);


    // >>>>>>>>>> NUEVO: limpiar polling al desmontar y al cerrar modal
    useEffect(() => {
        const el = modalElRef.current || document.getElementById('exampleModal');
        const onHidden = () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
        };

        if (el) el.addEventListener('hidden.bs.modal', onHidden);

        return () => {
            if (el) el.removeEventListener('hidden.bs.modal', onHidden);
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
        };
    }, []);



    const sincronizarPeriodo = async () => {

        setModalAnio(0)
        setModalNoPeriodo(0)
        const modal = new Modal(document.getElementById('exampleModalPeriodo'));
        modal.show();


    };

    const sincronizar = async () => {

        try {

            const resPadre = await api.get(`/Sync/localService/enProceso`);

            if (resPadre.status === 200) {

                try {
                    const res = await api.get(`/Sync/localService/cfdi`);
                    // abrir modal 
                    console.log("res.data", res.data)
                    handleEdit(res.data)
                    getDatos()
                    //
                } catch (e) {
                    //setErr("No se pudieron cargar las notificaciones.");
                    console.log("error en el catch")
                }
            }

        } catch (error) {
            const status = error?.response?.status;
            if (status === 402) {
                // 
                console.log("Actualmente existe un proceso de sincronización en curso.")
                window.alert("Actualmente existe un proceso de sincronización en curso.")
            } else {
                console.log("Ocurrio un error intentalo mas tarde.")
                window.alert("Ocurrio un error intentalo mas tarde.")
            }
        }

    };

    const fetchNotificaciones = async () => {
        try {
            const res = await api.get(`/Sync/localService/status`);
            setHttpCode(res.status)

        } catch (e) {
            //setErr("No se pudieron cargar las notificaciones.");
        } finally {
        }
    };



    const loadEmpleados = async (inputValue) => {
        try {
            const res = await api.get(`/empleados/select2?cadena=${inputValue}&pagina=1`);
            return (res.data?.results || []).map(emp => ({
                label: emp.text,
                value: String(emp.id),
                data: emp
            }));

        } catch (err) {
            console.error("Error al cargar empleados:", err);
            return [];
        }
    };



    useEffect(() => {
        getDatos();
    }, [page, limit, search]);



    const getDatos = async () => {
        try {
            const res = await api.get(
                `/actualizaciones/table?inicio=${(page - 1) * limit}&longitud=${limit}&orden=desc&ordenColumn=fecha&cadena=${search}`
            );
            setData(res.data.data);
            //setTotal(res.data.recordsTotal);
            setTotal(res.data.recordsFiltered);
        } catch (err) {
            console.error("Error al obtener datos:", err);
        }
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    const handleDelete = async (user) => {
        console.log(user)
        const confirmDelete = window.confirm(`¿Estás seguro que deseas eliminar la autorización "${user.autorizacion}"?`);

        if (confirmDelete) {
            await api.delete(`/autorizaciones/${user.idAutorizacion}`);

            getDatos();
        }

    };

    // >>>>>>>>>> CAMBIO: refreshData devuelve el estado actual
    const refreshData = async (id) => {
        try {
            const res = await api.get(`/Sync/localService/estatus/${id}`);
            setEditingUser(res.data.actualizacionesDto);
            setEstatusDto(res.data.estatusDto);
            return res.data.actualizacionesDto?.estado ?? null;
        } catch (err) {
            console.error("Error al obtener datos:", err);
            return null;
        }
    };

    // >>>>>>>>>> NUEVO: función para iniciar/gestionar el polling
    const startPolling = async (id) => {
        // limpia cualquier intervalo previo
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }

        const estado = await refreshData(id);
        if (estado === 'P') {
            pollingRef.current = setInterval(async () => {
                const e = await refreshData(id);
                if (e !== 'P') {
                    clearInterval(pollingRef.current);
                    pollingRef.current = null;
                }
            }, 5000); // 5s
        }
    };

    const handleEdit = (user) => {
        console.log("user", user)
        setEditingUser(user);

        const modal = new Modal(document.getElementById('exampleModal'));
        modal.show();

        // iniciar polling para ese id
        startPolling(user.idActualizacion);

    };

    const totalPages = Math.ceil(total / limit);

    const getValue = (key, fallback = '') => editingUser?.[key] ?? fallback;
    const getEmpleadoValue = (key, fallback = '') => editingUser?.idEmpleado?.[key] ?? fallback;



    const handleSubmitPeriodo = async (e) => {
        e.preventDefault();

        if (modalAnio != 0 && modalNoPeriodo != 0) {


            const payload = {
                anio: modalAnio,
                noPeriodo: modalNoPeriodo
            };

            try {

                await api.post(`/Sync/localService/periodo/${modalAnio}/${modalNoPeriodo}`);
                // crear un registro de sincronizacion y regresar el id tipo Periodo 
                // Nota el tipo periodo excluirlo de la sincronizacion automatica 
                // mostrar el modal de avance ya programado    
                // en el backend borrar periodo en postgres 
                // borrar archivos en s3 
                // sincronizar periodo webservice local
                // segunda vuelta 

                //getDatos();

                const modal = Modal.getInstance(document.getElementById('exampleModalPeriodo'));
                modal.hide();

            } catch (err) {
                console.error("Error al guardar usuario:", err);
            }

        } else {
            console.error("datos invalidos");
        }


    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            autorizacion: e.target.autorizacion.value,
            idEmpleado: {
                idEmpleado: selectedEmpleado?.value
            }
        };

        try {
            if (editingUser) {
                await api.put(`/autorizaciones/${editingUser.idAutorizacion}`, payload);
            } else {
                await api.post(`/autorizaciones`, payload);
            }
            getDatos();
            const modal = Modal.getInstance(document.getElementById('exampleModal'));
            modal.hide();

        } catch (err) {
            console.error("Error al guardar usuario:", err);
        }
    };

    const renderFooter = () => {
        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                <span>Mostrando {data.length} de {total} Registros</span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    {/* Botón anterior */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page > 1 && setPage(page - 1)}
                            disabled={page === 1}
                        >
                            <Icon icon="ep:d-arrow-left" />
                        </button>
                    </li>

                    {/* Calcular rango de páginas */}
                    {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(1, page - Math.floor(pagesToShow / 2));
                        let endPage = startPage + pagesToShow - 1;

                        if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - pagesToShow + 1);
                        }

                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                        }

                        return pageNumbers.map((num) => (
                            <li className="page-item" key={num}>
                                <button
                                    className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${page === num
                                        ? "bg-primary-600 text-white"
                                        : "bg-neutral-200 text-secondary-light"
                                        }`}
                                    onClick={() => setPage(num)}
                                >
                                    {num}
                                </button>
                            </li>
                        ));
                    })()}

                    {/* Botón siguiente */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page < totalPages && setPage(page + 1)}
                            disabled={page === totalPages}
                        >
                            <Icon icon="ep:d-arrow-right" />
                        </button>
                    </li>
                </ul>
            </div>
        )
    }


    return (
        <>

            <h6 className="text-md fw-medium text-secondary-light mb-2">Estatus servicio local {' '}
                {httpCode == 200 ? <span className='w-8-px h-8-px rounded-pill bg-success-600' /> : <span className='w-8-px h-8-px rounded-pill bg-danger-600' />}
            </h6>

            <div className="card h-100 p-0 radius-12">

                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <span className="text-md fw-medium text-secondary-light mb-0">Mostrar</span>
                        <select
                            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                            value={limit}
                            onChange={(e) => setLimit(parseInt(e.target.value))}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>
                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-neutra h-40-px w-auto"
                                name="search"
                                placeholder="Buscar"
                                value={search}
                                onChange={handleSearchChange}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>
                    </div>

                    {/* <button
                        type="button"
                        className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                        onClick={sincronizarPeriodo} >
                        <Icon icon="solar:refresh-outline" className="menu-icon" />
                        Sincronizar Periodo
                    </button>*/}

                    <button
                        type="button"
                        className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                        onClick={sincronizar} >
                        <Icon icon="solar:refresh-outline" className="menu-icon" />
                        Sincronizar
                    </button>
                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">Id</th>
                                    <th scope="col">Tipo</th>
                                    <th scope="col">Estatus</th>
                                    <th scope="col">Num. registros</th>
                                    <th scope="col">Fecha</th>
                                    <th scope="col" className="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((e) => (
                                    <tr key={e.idActualizacion}>
                                        <td>{e.idActualizacion}</td>
                                        <td>{e.tipo}</td>
                                        <td>{e.estado}</td>
                                        <td>{e.noRegistros}</td>
                                        <td>{e.fecha}</td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                <button
                                                    type="button"
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleEdit(e)}
                                                >
                                                    <Icon icon="lucide:eye" className="menu-icon" />
                                                </button>

                                                {/*  
                                                <button
                                                    type="button"
                                                    className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleDelete(e)}
                                                >
                                                    <Icon icon="lucide:trash" className="menu-icon" />
                                                </button>
                                            */}


                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {renderFooter()}
                </div>
            </div>


            {/* Modal */}
            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border-bottom">
                            <h5 className="modal-title">
                                Sincronización
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body p-24">
                            <form onSubmit={handleSubmit}>


                                <div className="row">

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Tipo</label>
                                        <input
                                            type="text"
                                            name="tipo"
                                            required
                                            className="form-control"
                                            disabled={true}
                                            value={getValue('tipo')} />
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Estatus</label>
                                        <input
                                            type="text"
                                            name="estado"
                                            required
                                            className="form-control"
                                            disabled={true}
                                            value={getValue('estado') === "T" ? "Terminado" : "En Proceso"} />
                                    </div>

                                </div>

                                <div className="row">

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Num. Registros</label>
                                        <input
                                            type="text"
                                            name="noRegistros"
                                            required
                                            className="form-control"
                                            disabled={true}
                                            value={getValue('noRegistros')} />
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Fecha</label>
                                        <input
                                            type="text"
                                            name="fecha"
                                            required
                                            className="form-control"
                                            disabled={true}
                                            value={getValue('fecha')} />
                                    </div>

                                    <SupportTracker dataSet={estatusDto} />

                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>




            {/* Modal */}
            <div className="modal fade" id="exampleModalPeriodo" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border-bottom">
                            <h5 className="modal-title">
                                Sincronizar Periodo
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body p-24">
                            <form >


                                <div className="row">

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Año</label>
                                        <input
                                            type="number"
                                            name="m_anio"
                                            required
                                            className="form-control"
                                            value={modalAnio}
                                            onChange={(e) => setModalAnio(e.target.value)} />
                                    </div>

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Periodo</label>
                                        <input
                                            type="number"
                                            name="m_no_periodo"
                                            required
                                            className="form-control"
                                            value={modalNoPeriodo}
                                            onChange={(e) => setModalNoPeriodo(e.target.value)} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6 mb-20">
                                        <button
                                            type="button"
                                            className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                                            onClick={handleSubmitPeriodo} >
                                            Sincronizar
                                        </button>
                                    </div>
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>



        </>

    );
}